import axios from "axios"
import { useNavigate } from 'react-router-dom';
import logo from '../logo.svg';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import React from "react"
// import jsPDF from "jspdf"
import { useRef, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { isAuth } from '../helpers/auth';

const NoPage = () => {
  const navigate = useNavigate()
  const productData = { name: 'Laptop', price: 1200 }
  const { id, idc } = useParams();
  const [title, setTitle] = useState("www")
  const [wwwww, setWww] = useState([])
  const [zz, setZz] = useState([])
  const [units, setUnits] = useState([])
  console.log(wwwww)

  useEffect(() => {
    if (isAuth()) {
      //   console.log(JSON.parse(localStorage.getItem("user")).name)
      //   console.log(JSON.parse(localStorage.getItem("user"))._id)
      getNotes()
    }
    // getNotes()
    // setFormData({ ...formData, rol:"3", name:"www", email:"www", foto:"www", password:"www" })
  }, []);
  // const [edit, setEdit] = useState()
  
  const getNotes = async () => {
    console.log("res.data[0]");
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/curses/ControllerAll/${id}/${isAuth()._id}`
    ).then(res => {
      console.log(res.data[0], "www")
      setZz(res.data[0])
      setUnits(res.data[0].units)
    });
    // });
  };

  // const get = async () => {
  //   await fetch(`${process.env.REACT_APP_API_URL}/curses/ControllerAll/${id}/${isAuth()._id}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data.items === undefined)
  //       if (data.items === undefined) {
  //         fetch(`${process.env.REACT_APP_URL}/api/curses/ControllerAllwww/${id}/${JSON.parse(localStorage.getItem("user"))._id}`)
  //           .then((response) => response.json())
  //           .then((data) => {
  //             console.log(data, "wwwwwwwwwwwwwwwwwwwwww")
  //             setWww(data[0])
  //           })
  //           // .then(response => response.json())
  //           // .then(data => { toast.warning(data); getNotes() })
  //           .catch(error => console.error(error))
  //       } else {
  //         setWww(data.items)
  //       }

  //     })
  //     // .then(response => response.json())
  //     // .then(data => { toast.warning(data); getNotes() })
  //     .catch(error => console.error(error))
  // }


  // const createSesion = async (idcurso, codigocurso) => {
  // // e.preventDefault()
  // // console.log(idunidad, codigocurso)
  // fetch(process.env.REACT_APP_URL + "/api/sections/section", {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify({
  //     title: 'www',
  //     description: 'www',
  //     img: 'www',
  //     test: 'www',
  //     codecurse: codigocurso,
  //     task: 'www',
  //     time: 'www',
  //     timeex: 'www',
  //     conceptual: '0.5',
  //     procedimental: '0.5',
  //     actitudinal: '0.5',
  //     curse: idcurso,
  //     user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))._id : '63ab4f45a06c6fe92e7a4209'
  //   })
  // }).then(response => response.json())
  //   .then(data => { toast.warning(data); getNotes() })
  //   .catch(error => console.error(error))
  // }



  const createTheme = async (idunidad, idcurso) => {
    // // e.preventDefault()
    // // console.log(idunidad, codigocurso)
    // fetch(process.env.REACT_APP_URL + "/api/sections/theme", {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     title: 'www',
    //     description: 'www',
    //     task: 'www',
    //     dateb: 'www',
    //     datee: 'www',
    //     solution: 'www',
    //     img: 'www',
    //     time: 'www',
    //     unidad: idunidad,
    //     curse: idcurso,
    //     user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))._id : '63ab4f45a06c6fe92e7a4209'
    //   })
    // }).then(response => response.json())
    //   .then(data => { toast.warning(data); getNotes() })
    //   .catch(error => console.error(error))
  }

  // const deleteS = (item) => {

  // }

  // const deleteT = (item) => {
  //   console.log(item)
  //   for (var k = 0; k < wwwww.unidades.length; k++) {
  //     for (var j = 0; j < wwwww.unidades[k].temas.length; j++) {
  //       if (wwwww.unidades[k].temas[j]._id === item) {
  //         const idsToRemove = [item]
  //         const filteredUsers = wwwww.unidades[k].temas.filter(user => !idsToRemove.includes(user._id));
  //         wwwww.unidades[k].temas = filteredUsers
  //       }
  //       console.log(wwwww)
  //     }
  //   }
  //   setWww(wwwww)
  //   console.log(wwwww)

  //   fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
  //     method: 'put',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(wwwww)
  //   })
  //     .then(response => response.json())
  //     .then(data => { toast.info(data); getNotes() })
  //     .catch(error => console.error(error))
  // }

  const updateTheme = (event, idwww) => {
    console.log(event, idwww)
    for (var k = 0; k < wwwww.unidades.length; k++) {
      for (var j = 0; j < wwwww.unidades[k].temas.length; j++) {
        if (wwwww.unidades[k].temas[j]._id === idwww) {
          wwwww.unidades[k].temas[j].title = event
          console.log(wwwww.unidades[k].temas[j])
        }
      }
    }
    setTitle("wwwww")
    setWww(wwwww)
    console.log(wwwww)

    fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wwwww)
    })
      .then(response => response.json())
      .then(data => { toast.info(data); getNotes() })
      .catch(error => console.error(error))
  }

  const updateUnit = (event, description, idwww) => {
    console.log(event, description, idwww)
    for (var k = 0; k < wwwww.unidades.length; k++) {
      if (wwwww.unidades[k]._id === idwww) {
        wwwww.unidades[k].title = event
      }
    }
    setWww(wwwww)
    setTitle("wwwww")
    console.log(wwwww)

    fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wwwww)
    })
      .then(response => response.json())
      .then(data => { toast.info(data); getNotes() })
      .catch(error => console.error(error))
  }




  // const createSesion = (datos, idunit) => {
  //   for (var k = 0; k < datos.unidades.length; k++) {
  //     var data = []
  //     for (var j = 0; j < datos.unidades[k].temas.length; j++) {
  //       data.push(datos.unidades[k].temas[j])
  //     }

  //     data.push({
  //       "title": "Change title",
  //       "description": "www",
  //       "task": "www",
  //       "dateb": "www",
  //       "datee": "www",
  //       "solution": "www",
  //       "img": "www",
  //       "time": "www",
  //       "unidad": idunit,
  //       "curse": id,
  //       "user": "62cf3499f1443acd8c3dc429",
  //       "usertask": [],
  //       "usertaskteacher": []
  //     })
  //     datos.unidades[k].temas = data
  //   }
  //   // console.log(datos)
  //   // datos.unidades[1]['title'] = "Jane Doe"
  //   datos.title = "Jane Doe"
  //   // setWww([])
  //   setWww(datos)
  //   setTitle("datos")

  //   fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
  //     method: 'put',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(datos)
  //   })
  //     .then(response => response.json())
  //     .then(data => { toast.info(data); getNotes() })
  //     .catch(error => console.error(error))
  // }


  const createItems = () => {
    // // console.log(datos)
    // // datos.unidades[1]['title'] = "Jane Doe"
    // datos.title = "Jane Doe"
    // // setWww([])
    // setWww(datos)
    // setTitle("datos")

    fetch(`${process.env.REACT_APP_URL}/api/curses/${id}`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wwwww)
    })
      .then(response => response.json())
      .then(data => { toast.info(data); getNotes() })
      .catch(error => console.error(error))
  }



  const CreateTheme = async (i) => {
    var data = zz ? zz : []
    console.log(i)
    // if (data.units === undefined) {
    //   data.units = []
    // }
    data.units[i].themes.push(
      {
        "title": "title",
        "detail": "detail",
        "idtheme": Math.random().toString(36).substring(2, 11).toUpperCase(),
        "createdAt": new Date(),
        "updatedAt": new Date(),
      }
    )
    setUnits(data.units)
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/` + id,
      data
    )
  }
  const remove = async (i) => {
    const response = window.confirm("Deseas eliminar este item?");
    if (response) {
      var data = zz ? zz : []
      data.units.splice(i, 1);
      console.log(units, "www")
      setUnits(data.units)
      await axios.put(
        `${process.env.REACT_APP_API_URL}/curses/` + id,
        data
      )
    }
  }

  const removeTheme = async (i, j) => {
    const response = window.confirm("Deseas eliminar este item?");
    if (response) {
      var data = zz ? zz : []
      data.units[i].themes.splice(j, 1);
      setUnits(data.units)
      await axios.put(
        `${process.env.REACT_APP_API_URL}/curses/` + id,
        data
      )
    }
  }


  const goToProductPage = ( idt, id, title, number, numberr) => {
    navigate('/tema', { state: { title: title, id: id, idt: idt, number, numberr } });
  }


  return <div className="contenedor">
    <ToastContainer
      position="bottom-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false}
    />
    {/* <button className="button" onClick={handleGeneratePdf}>
      Generate PDF {id}
    </button> */}
    <Link className="btn btn-info m-1" style={{ color: 'orange' }} to={'/forum/' + id} > FORUM </Link>

    {wwwww ?
      < div style={{ width: '100%', border: '00px solid rgba(255, 155, 155, .0011)' }} key={wwwww._id}>

        <div style={{ fontSize: '15px', padding: '.1cm', textAlign: 'center' }}>{wwwww.title} {wwwww.requisito} {wwwww.ciclo} {wwwww.credito} {wwwww.year} {wwwww.mencion} {wwwww.codigo} {wwwww._id}</div>
        {localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).rol == '2' ? <div style={{ alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', display: 'flex' }}>
          {/* <button onClick={() => deleteS(wwwww._id)}>errase</button> */}
          {/* <button onClick={() => update(wwwww._id)}>update</button> */}
          <button onClick={() => createItems()} >
            Crear unidad
          </button>
          {/* <button onClick={() => New(wwwww)} >
            Www
          </button> */}
        </div> : null}

        <div className="row d-flex justify-content-center p-1">
          {units.map((note, i) => (
            <div
              className="col-md-6 col-lg-6 p-1"
              key={note._id}
            >
              <div className="" contentEditable="true" suppressContentEditableWarning={true} onBlur={(e) => { updateUnit(e.target.innerText, i) }}>
                {note.title}
              </div>
              <a className="btn text-center" onClick={() => { CreateTheme(i) }}>
                {/* <IoMdAlert style={{ color: '#3d85bdff', fontSize: '34px' }} /> */}
              </a>
              <a className="btn text-center" onClick={() => { remove(i) }}>
                {/* <IoMdAlert style={{ color: '#bd3d79ff', fontSize: '34px' }} /> */}
              </a>

              <div className="row d-flex justify-content-center p-1">
                {note.themes ? note.themes.map((notte, j) => (
                  <div
                    className="col-md-6 col-lg-6 p-1"
                    key={j}
                  >
                    <div className="" contentEditable="true" suppressContentEditableWarning={true} onBlur={(e) => { updateTheme(e.target.innerText, i, j) }}>
                      {notte.title} {zz._id} {zz.title} {notte.idtheme}
                    </div>
                    {isAuth() && JSON.parse(localStorage.getItem("user")).rol == '2' ? <button className="btn btn-info" onClick={() => goToProductPage(notte.idtheme, zz._id, zz.title, i + 1, j + 1)}>Ir a la sesion</button> : null}
                    {/* <a className="btn text-center" onClick={() => { CreateTheme(i) }}>
                        <IoMdAlert style={{ color: '#3d85bdff', fontSize: '34px' }} />
                      </a> */}
                    <a className="btn text-center" onClick={() => { removeTheme(i, j) }}>
                      {/* <IoMdAlert style={{ color: '#bd3d79ff', fontSize: '34px' }} /> */}
                    </a>

                  </div>
                )) : ""}
              </div>

            </div>
          ))}
        </div>
      </div>
      : <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    }
    {/* <img src={logo} width="100%" height="" />
    <img src={'../esfap.png'} width="100%" height="" /> */}
  </div >
}

export default NoPage;

